import { Stack, Text, ContentBlock, Box, Heading } from 'braid-design-system';
import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';

const NotFound = () => (
  <ContentBlock>
    <Box marginY="large">
      <Stack space="medium">
        <Heading level="3">Sorry, page cannot be found</Heading>
        <Text weight="regular">
          Please check the spelling of the URL you entered (i.e. the web
          address.) If you are sure you entered the correct URL it is likely
          that this document is no longer available or has been moved.
        </Text>
        <Text>
          Return to the{' '}
          <ExternalLink
            destination={`${getConfigValues().HEADER_SERVER_BASE}${
              Routes.ROOT
            }`}
          >
            SEEK Business Homepage
          </ExternalLink>
        </Text>
      </Stack>
    </Box>
  </ContentBlock>
);

export default NotFound;
